<template>
  <div v-if="section" class="w-full flex flex-col items-center gap-5">
    <div
      :id="`section_field_${section.id}`"
      class="form-section w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-red-salmon rounded-xl"
    >
      <input
        type="text"
        :name="`section_name_${section.id}`"
        :id="`section_name_${section.id}`"
        class="name-input mb-2 focus:border-light-purple"
        placeholder="Section name"
        v-model="nameInput"
      />
      <textarea
        type="text"
        :name="`section_description_${section.id}`"
        :id="`section_description_${section.id}`"
        class="description-input focus:border-light-purple"
        placeholder="Description (optional)"
        v-model="descriptionInput"
      ></textarea>
    </div>
    <ParentFormQuestion
      v-for="question in section.questions"
      :key="question.id"
      :question="question"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import debounce from "lodash/debounce";

import ParentFormQuestion from "./Question.vue";

import BlIcon from "../../../BlIcon.vue";

export default {
  name: "ParentFormSection",
  components: { ParentFormQuestion, BlIcon },
  props: {
    section: { type: Object, required: true }
  },
  data() {
    return {
      saveLoading: false,
      nameInput: "",
      descriptionInput: ""
    };
  },
  watch: {
    nameInput(val) {
      if (val && val !== this.section.name) {
        this.onEditing();
      }
    },
    descriptionInput(val) {
      if (val !== this.section.description) {
        this.onEditing();
      }
    }
  },
  mounted() {
    this.nameInput = this.section.name;
    this.descriptionInput = this.section.description;
  },
  methods: {
    ...mapActions(["updateParentFormSection"]),
    onEditing: debounce(function() {
      const data = {
        id: this.section.id,
        section: {
          name: this.nameInput,
          description: this.descriptionInput
        }
      };
      this.saveLoading = true;
      this.updateParentFormSection(data).then(({ success }) => {
        this.saveLoading = false;
        if (!success) {
          this.nameInput = this.section.name;
          this.descriptionInput = this.section.description;
          // return;
        }
      });
    }, 1000)
  }
};
</script>

<style scoped lang="scss">
.form-section {
  .name-input {
    width: 32rem;
    height: 2rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 1rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-10, #1d2939);
    //
    outline: none;
  }
  .description-input {
    width: 32rem;
    height: 6.25rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-7, #475467);
    //
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/center/salesPipeline/parentForm/Section.vue